var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureAbove40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 208,
    viewBox: "0 0 173 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.268 142.64C61.268 142.64 58.6289 143.68 59.2026 145.993C59.7767 148.306 63.9084 148.306 66.2037 149.694C68.4983 151.081 69.3016 153.163 68.6135 154.897C68.6135 154.897 72.8593 153.509 72.5151 150.503C72.1703 147.496 69.4739 147.843 70.2775 144.027C71.0801 140.211 73.3178 139.807 73.3178 139.807C73.3178 139.807 70.6213 142.293 72.7444 144.548C74.8671 146.803 79.4003 149.751 79.286 154.665C79.286 154.665 91.2211 148.19 93.4591 142.813C95.6961 137.436 94.6066 132.753 90.1307 132.811C90.1307 132.811 90.7047 130.961 94.1474 131.423C97.5902 131.886 98.566 135.297 98.566 135.297C98.566 135.297 98.1636 123.213 110.901 121.941C110.901 121.941 106.77 123.618 105.45 128.301C104.131 132.984 106.54 136.222 108.435 138.246C110.328 140.269 113.255 145.241 112.508 148.941C112.508 148.941 114.402 145.068 117.902 145.009C117.902 145.009 114.345 146.57 114.688 151.485C115.033 156.399 117.845 155.821 120.024 160.272C122.205 164.724 122.951 169.176 122.263 171.258C122.263 171.258 123.869 169.582 123.812 166.401C123.812 166.401 129.034 178.947 114.861 184.96C100.688 190.973 60.494 201.727 52.9195 191.84C45.345 181.954 46.8087 179.092 49.8209 171.2C52.8335 163.308 54.2106 158.365 50.7675 156.457C50.7675 156.457 55.501 156.457 56.276 160.793C56.276 160.793 57.9112 158.191 55.501 154.896C53.0914 151.6 54.8127 147.612 56.5342 145.53C58.256 143.449 61.268 142.64 61.268 142.64Z",
    fill: "url(#paint0_linear_917_8848)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.706 178.093C122.79 175.578 119.97 166.942 112.267 163.334C113.894 164.865 113.243 169.238 113.243 169.238C113.243 169.238 113.785 164.428 107.818 160.273C101.851 156.119 99.6806 147.264 107.058 142.126C100.332 140.159 97.2454 149.537 94.1472 146.936C92.4116 145.478 100.284 136.153 92.586 133.414C94.9243 134.84 95.2053 138.615 93.4588 142.813C91.2205 148.19 79.2857 154.665 79.2857 154.665C79.4 149.751 74.8668 146.803 72.7441 144.548C70.6211 142.293 73.3175 139.807 73.3175 139.807C73.3175 139.807 71.0799 140.211 70.2772 144.027C69.4736 147.843 72.17 147.496 72.5148 150.503C72.859 153.509 68.6133 154.897 68.6133 154.897C69.3013 153.162 68.498 151.081 66.2034 149.694C65.6394 149.353 64.9644 149.096 64.2587 148.868C66.6381 150.83 68.8471 153.788 64.8538 156.229C58.2353 160.273 58.7777 165.411 60.9476 167.489C57.8018 165.411 56.9336 165.63 56.1736 162.46C56.1736 162.46 56.0498 160.866 54.2048 159.663C55.0727 163.27 54.9761 166.402 52.1595 171.315C50.2212 174.697 47.7489 179.068 47.9918 183.594C48.7564 185.834 50.295 188.416 52.9195 191.842C60.494 201.729 100.688 190.974 114.861 184.962C121.346 182.21 123.769 178.092 124.491 174.433C123.91 175.911 123.032 177.271 121.706 178.093Z",
    fill: "url(#paint1_linear_917_8848)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.626 186.636C116.5 186.658 116.369 186.689 116.238 186.722C116.732 186.263 117.182 185.768 117.549 185.229C118.862 183.303 119.061 180.556 119.026 178.298C118.992 176.077 118.777 173.652 117.881 171.596C117.334 170.341 116.642 169.155 115.813 168.069C115.245 167.323 114.253 165.851 113.229 165.749C114.065 165.833 114.48 167.494 114.638 168.134C114.974 169.492 114.802 170.913 114.471 172.255C114.189 173.401 113.695 174.438 112.952 175.353C112.769 175.579 112.572 175.781 112.369 175.973C113.123 172.991 112.96 169.838 111.507 167.047C110.086 164.316 107.585 162.359 105.373 160.316C103.042 158.165 101.055 155.769 100.463 152.562C99.8182 149.065 100.877 146.052 103.48 143.72C101.144 143.897 98.342 146.025 97.0583 147.943C96.4473 148.856 96.1242 149.897 95.955 150.968C95.4776 150.386 94.8804 149.89 94.314 149.403C92.4299 147.786 90.4782 146.369 88.4662 144.918C86.1822 143.271 84.243 141.352 83.2769 138.637C82.6797 136.959 82.6218 135.137 83.1528 133.435C83.5382 132.243 84.0345 130.831 85.0914 130.086C82.5245 130.665 80.0698 133.511 79.0973 135.853C78.0636 138.342 77.8425 141.227 78.783 143.747C78.3989 143.494 78.0029 143.29 77.6249 143.148C76.7597 142.823 75.3701 142.944 74.4803 143.145C73.612 143.344 72.8017 144.014 72.5088 144.43C75.1689 143.97 76.0338 147.21 76.1146 147.983C76.3055 149.802 75.5147 151.47 74.2437 152.717C72.4265 154.5 69.8769 155.372 67.6292 156.444C62.6408 158.824 59.3932 163.409 62.211 168.819C62.9939 170.324 63.9316 171.824 63.8697 173.586C63.8283 174.762 63.3179 175.871 62.5555 176.751C62.9859 175.781 63.2378 174.731 63.1789 173.672C63.1009 172.272 62.4918 170.899 61.6665 169.791C60.2578 167.901 57.9125 166.798 55.6017 167.131C55.1853 167.191 54.9197 167.06 54.5536 167.316C54.6746 167.232 55.8169 167.155 56.6916 168.735C57.2126 169.675 57.1613 170.902 56.8845 171.868C56.4047 173.543 55.2115 174.99 54.1911 176.36C51.334 180.196 50.3115 184.796 52.1074 189.354C53.8701 193.828 57.8573 197.093 62.1113 198.743C69.3584 201.555 76.1164 202.065 82.7282 201.786C89.4106 201.503 93.229 201.324 100.115 200.456C102.668 200.135 107.221 198.785 109.292 197.211C111.335 195.657 112.227 193.318 113.609 191.251C114.895 189.326 116.885 187.293 119.366 187.958C119.031 186.99 117.56 186.47 116.626 186.636Z",
    fill: "url(#paint2_linear_917_8848)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.948 190.902C112.21 188.359 114.734 187.665 114.734 187.665C114.734 187.665 113.241 187.318 110.374 189.052C115.651 183.734 113.586 178.533 113.586 178.533C112.325 181.308 108.882 182.001 108.882 182.001C111.407 178.417 110.489 171.828 104.637 168.014C99.1306 164.199 97.7548 158.187 98.4426 155.876C96.0994 157.314 95.9275 160.935 95.9186 161.73C95.9205 161.832 95.9186 161.887 95.9186 161.887C95.9186 161.887 95.9174 161.83 95.9186 161.73C95.8973 160.738 95.4888 155.248 89.1499 150.327C82.1522 144.894 80.7749 138.42 80.7749 138.42C78.7098 142.35 81.6922 147.322 81.0044 149.98C80.7749 147.668 77.9065 146.628 77.9065 146.628C79.3988 150.096 78.2507 154.026 73.3175 156.222C68.3843 158.418 62.6478 162.812 64.7123 169.747C66.7774 176.683 62.6478 181.191 62.6478 181.191C62.6478 181.191 62.7621 177.723 60.4684 176.914C61.2713 179.573 60.9269 180.035 58.2883 187.202C56.682 191.667 59.8638 195.998 63.5843 199.283C70.278 201.618 76.5663 202.045 82.7284 201.785C89.4109 201.502 93.2292 201.323 100.115 200.456C100.991 200.345 102.106 200.111 103.273 199.791C108.208 196.58 110.086 192.637 110.948 190.902Z",
    fill: "url(#paint3_linear_917_8848)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9189 161.885C95.9189 161.885 95.9208 161.831 95.9189 161.729C95.9177 161.828 95.9189 161.885 95.9189 161.885Z",
    fill: "url(#paint4_linear_917_8848)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6748 157.931C76.6748 157.931 72.0267 159.839 74.6948 164.349C77.3629 168.858 79.9456 172.587 78.3961 175.709C78.3961 175.709 81.0642 173.02 79.9456 169.986C79.9456 169.986 83.3884 172.587 82.6997 177.357C82.011 182.126 78.4817 183.774 79.9456 187.503C79.9456 187.503 80.2895 185.249 83.6466 183.341C87.0031 181.433 89.2413 175.709 85.9705 169.811C82.6997 163.915 80.548 158.364 85.3678 154.027C85.3678 154.027 83.4744 157.931 86.6592 162.266C89.8434 166.603 96.9874 172.153 97.2454 178.31C97.5039 184.468 95.5244 187.503 95.5244 187.503C95.5244 187.503 97.4179 185.855 98.7087 182.906C99.9994 179.958 103.959 177.356 107.573 177.876C107.573 177.876 103.787 178.744 102.496 183.08C101.205 187.416 104.647 195.655 97.4179 199.124C90.1882 202.593 76.7602 202.073 70.0475 198.777C63.3343 195.482 61.0104 189.671 63.2477 185.248C65.4854 180.825 66.6042 179.611 65.9158 177.01C65.9158 177.01 68.6702 178.831 67.637 184.208C67.637 184.208 70.0472 184.035 70.4774 179.005C70.9075 173.974 68.6699 174.321 68.412 169.378C68.1541 164.435 71.5109 159.405 76.6748 157.931Z",
    fill: "url(#paint5_linear_917_8848)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5187 132.434C66.5187 132.434 64.281 134.688 65.6581 137.117C67.0354 139.545 68.2402 142.147 65.3139 144.488C65.3139 144.488 66.2602 143.361 64.453 141.713C62.6455 140.066 61.9574 135.99 66.5187 132.434Z",
    fill: "url(#paint6_linear_917_8848)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1376 122.723C78.1376 122.723 75.814 124.457 76.589 126.712C77.363 128.967 79.6013 132.262 75.126 134.517C75.126 134.517 76.8469 132.869 75.5558 130.354C74.2651 127.839 74.0925 124.197 78.1376 122.723Z",
    fill: "url(#paint7_linear_917_8848)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9498 179.814C73.9498 179.814 75.3833 180.508 75.0967 183.919C74.8098 187.33 74.6379 189.295 76.3594 190.914C78.0806 192.533 82.1538 195.251 81.8103 198.315C81.4658 201.379 77.335 200.512 74.2937 197.91C71.2521 195.309 70.5991 192.621 70.9083 189.469C71.3674 184.786 75.3263 182.474 73.9498 179.814Z",
    fill: "url(#paint8_linear_917_8848)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6625 199.762C86.2507 199.079 82.6711 196.582 83.1302 191.725C83.5893 186.868 89.2118 184.325 90.245 180.914C91.2781 177.503 90.9339 176.115 90.9339 176.115C90.9339 176.115 93.1143 179.18 92.3113 182.418C91.508 185.655 88.8679 188.372 90.6477 192.073C93.2627 197.514 93.7289 199.362 91.9095 199.993C90.245 200.572 89.0981 200.455 87.6625 199.762Z",
    fill: "url(#paint9_linear_917_8848)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.796 130.701C119.796 130.701 118.075 131.656 118.591 133.477C119.107 135.298 119.925 138.81 116.095 139.287C116.095 139.287 116.654 138.984 116.009 137.899C115.364 136.816 114.933 134.734 116.74 132.913C118.547 131.092 119.796 130.701 119.796 130.701Z",
    fill: "url(#paint10_linear_917_8848)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.714 153.42C127.714 153.42 126.38 154.114 126.853 156.325C127.327 158.537 127.887 162.526 123.97 163.87C123.97 163.87 124.917 162.83 124.573 160.228C124.228 157.626 124.444 154.548 127.714 153.42Z",
    fill: "url(#paint11_linear_917_8848)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.007 190.107C65.5144 188.083 66.7201 185.887 66.7201 185.887C61.9 191.032 69.3589 196.813 69.5888 195.311C69.8177 193.808 68.4983 192.13 67.007 190.107Z",
    fill: "url(#paint12_linear_917_8848)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7705 186.059C99.7693 186.059 99.0983 187.028 99.5986 189.297C99.926 190.784 99.3319 193.036 98.2649 194.088C96.0815 196.236 95.879 193.058 96.3845 191.45C97.2024 188.849 98.5798 187.027 99.7705 186.059Z",
    fill: "url(#paint13_linear_917_8848)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1409 153.684C44.1409 153.684 42.5053 155.679 44.1409 156.979C45.7755 158.28 48.111 160.951 46.2929 163.831C45.6895 164.785 46.2929 163.137 45.0015 162.269C43.24 161.086 39.3211 157.846 44.1409 153.684Z",
    fill: "url(#paint14_linear_917_8848)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1539 158.455C75.1539 158.455 67.902 163.964 71.7493 169.258C76.4498 175.728 72.0023 179.497 69.5314 183.083C70.6185 180.195 71.1664 177.272 69.4451 173.456C67.9132 170.061 67.4252 162.735 75.1539 158.455Z",
    fill: "url(#paint15_radial_917_8848)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.178 154.449C85.178 154.449 82.5824 159.535 89.8127 165.952C97.0418 172.37 98.2789 178.487 96.3845 183.17C96.9019 176.926 95.3675 172.971 88.6768 168.493C82.0974 164.09 82.4236 157.05 85.178 154.449Z",
    fill: "url(#paint16_radial_917_8848)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5081 170.633C80.5081 170.633 83.1583 175.38 79.9192 179.436C76.6791 183.491 79.9457 187.503 79.9457 187.503C79.9457 187.503 78.1525 185.272 80.9987 181.809C83.8451 178.348 83.1583 173.007 80.5081 170.633Z",
    fill: "url(#paint17_radial_917_8848)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M84.5501 130.314C84.5501 130.314 77.689 137.919 89.2918 145.588C83.3032 144.268 77.2436 135.537 84.5501 130.314Z",
    fill: "url(#paint18_radial_917_8848)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.044 143.988C103.044 143.988 95.9334 150.694 103.409 158.41C95.2033 155.195 96.1154 147.019 103.044 143.988Z",
    fill: "url(#paint19_radial_917_8848)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.8139 144.288C72.8139 144.288 74.4077 144.021 75.4695 145.703C76.5316 147.385 76.9496 150.596 73.876 153.195C78.2026 150.94 78.1638 142.912 72.8139 144.288Z",
    fill: "url(#paint20_radial_917_8848)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.738 167.08C114.738 167.08 120.637 177.354 115.538 183.901C110.439 190.448 126.134 181.685 114.738 167.08Z",
    fill: "url(#paint21_radial_917_8848)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2831 167.199C55.2831 167.199 60.1209 169.12 55.416 175.133C51.3995 180.452 50.2524 185.541 53.1211 189.934C51.7437 186.002 52.6318 179.619 57.3671 177.099C63.449 173.862 61.4363 168.218 55.2831 167.199Z",
    fill: "url(#paint22_radial_917_8848)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9743 156.707C67.9743 156.707 61.0488 160.196 62.5405 167.282C59.6642 162.719 62.5405 159.176 67.9743 156.707Z",
    fill: "url(#paint23_radial_917_8848)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M74.3162 182.693C74.3162 182.693 69.9561 189.768 76.7121 193.928C82.812 197.71 63.5255 197.348 74.3162 182.693Z",
    fill: "url(#paint24_radial_917_8848)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.0602 177.631C91.0602 177.631 91.28 181.631 87.7031 184.915C84.7765 187.604 81.7526 191.408 84.9374 195.918C87.6918 199.126 90.0151 196.525 88.036 193.489C86.0569 190.454 86.3261 188.991 89.2524 185.869C92.179 182.747 91.0602 177.631 91.0602 177.631Z",
    fill: "url(#paint25_radial_917_8848)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.6219 143.449C59.6219 143.449 51.2484 147.755 56.1041 155.589C57.4818 157.324 57.3955 159.665 56.7928 161.052C61.4983 158.827 64.1383 154.433 61.1541 151.426C58.5655 148.819 54.6185 148.827 59.6219 143.449Z",
    fill: "url(#paint26_radial_917_8848)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.719 122.383C109.719 122.383 99.2813 126.843 102.395 138.406C103.762 143.251 95.9739 137.858 99.9627 129.268C102.641 124.091 107.206 122.492 109.719 122.383Z",
    fill: "url(#paint27_radial_917_8848)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M116.828 145.277C116.828 145.277 111.632 150.761 115.992 155.733C120.355 160.706 121.898 163.878 121.898 167.579C121.898 167.579 119.037 162.132 113.981 157.982C108.004 153.076 113.155 147.59 116.828 145.277Z",
    fill: "url(#paint28_radial_917_8848)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.7169 156.912C51.7169 156.912 55.0011 159.098 51.5413 167.371C55.823 163.116 54.2975 157.857 51.7169 156.912Z",
    fill: "url(#paint29_radial_917_8848)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0142 185.041C65.0142 185.041 61.6546 193.66 71.532 196.431C81.4097 199.201 77.2347 191.608 85.4826 194.481C93.7311 197.354 100.452 192.634 100.757 185.862C102.285 191.608 100.452 197.969 90.6767 199.713C80.9006 201.458 57.8863 198.996 65.0142 185.041Z",
    fill: "url(#paint30_radial_917_8848)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.5128 201.846C78.8748 201.846 73.412 200.816 69.897 199.09C66.1735 197.262 63.56 194.56 62.5369 191.48C61.8034 189.273 61.9427 187.064 62.9417 185.092C63.3603 184.264 63.7401 183.547 64.0761 182.915C65.5141 180.205 66.1083 179.083 65.583 177.1L65.351 176.222L66.1052 176.721C66.2202 176.797 68.8401 178.596 68.0758 183.688C68.7252 183.326 69.8559 182.235 70.1351 178.975C70.3586 176.364 69.8534 175.29 69.2693 174.045C68.7636 172.969 68.1911 171.75 68.0688 169.396C67.7932 164.134 71.4527 159.061 76.5804 157.598L76.8051 158.252C76.7862 158.26 74.9244 159.048 74.3702 160.724C74.0327 161.745 74.2409 162.905 74.9906 164.171C75.236 164.586 75.4799 164.994 75.721 165.395C77.6358 168.588 79.3424 171.437 79.1982 173.983C79.7311 172.981 80.1646 171.577 79.6223 170.107L79.2147 169L80.1518 169.709C80.2994 169.82 83.75 172.491 83.04 177.407C82.7376 179.505 81.9087 181.005 81.178 182.328C80.3963 183.742 79.7509 184.911 79.9902 186.396C80.446 185.511 81.4203 184.209 83.4772 183.039C88.1577 180.379 87.7574 173.747 85.6694 169.982C82.6815 164.595 79.9308 158.455 85.1384 153.77L86.4489 152.592L85.6774 154.182C85.6042 154.333 83.9214 157.958 86.9361 162.061C87.8049 163.246 88.9857 164.534 90.2347 165.898C93.5924 169.563 97.3976 173.716 97.5899 178.296C97.7305 181.653 97.222 184.092 96.7129 185.645C97.2601 184.913 97.878 183.945 98.3938 182.768C99.6959 179.794 103.313 177.464 106.628 177.464C106.965 177.464 107.299 177.488 107.623 177.534L109.448 177.798L107.651 178.216C107.504 178.25 104.04 179.101 102.826 183.181C102.448 184.45 102.494 186.117 102.543 187.882C102.654 191.913 102.793 196.93 97.5656 199.438C94.3307 200.99 89.696 201.846 84.514 201.846H84.5128ZM66.45 178.068C66.5704 179.685 65.8958 180.955 64.6831 183.242C64.3492 183.872 63.9709 184.584 63.5551 185.407C62.6427 187.209 62.5161 189.234 63.1896 191.261C64.1535 194.162 66.643 196.721 70.1985 198.466C73.6236 200.148 78.9748 201.153 84.5128 201.153H84.5143C89.5954 201.152 94.1259 200.321 97.2698 198.812C102.092 196.498 101.966 191.932 101.855 187.902C101.804 186.079 101.756 184.358 102.166 182.981C102.96 180.316 104.639 178.909 105.903 178.199C103.087 178.51 100.11 180.566 99.024 183.047C97.7165 186.034 95.8291 187.697 95.7492 187.767L93.907 189.37L95.2358 187.314C95.255 187.284 97.1513 184.279 96.9019 178.326C96.7208 174 93.0061 169.945 89.7295 166.368C88.4677 164.991 87.2745 163.689 86.3822 162.474C84.2518 159.572 84.3006 156.874 84.6161 155.299C81.4898 159.039 82.9324 163.623 86.2715 169.643C87.7964 172.392 88.2781 175.414 87.6284 178.154C87.0599 180.558 85.6338 182.61 83.8165 183.643C80.6692 185.432 80.2896 187.537 80.2853 187.559L80.082 188.793L79.6256 187.631C78.7263 185.34 79.583 183.788 80.5768 181.991C81.2795 180.719 82.0749 179.279 82.359 177.308C82.7989 174.262 81.4673 172.13 80.5442 171.058C80.8088 173.731 78.7406 175.854 78.64 175.955L77.1395 177.466L78.0879 175.555C79.411 172.891 77.4276 169.583 75.1317 165.754C74.8912 165.351 74.6461 164.942 74.3998 164.526C73.5419 163.077 73.3136 161.722 73.7199 160.499C73.8745 160.034 74.1074 159.629 74.3757 159.283C70.8509 161.317 68.5435 165.279 68.7563 169.361C68.8721 171.578 69.3907 172.681 69.8922 173.748C70.493 175.027 71.061 176.237 70.8217 179.035C70.3708 184.3 67.7725 184.547 67.663 184.555L67.2152 184.587L67.3003 184.143C67.924 180.892 67.1195 179.009 66.45 178.068Z",
    fill: "url(#paint31_linear_917_8848)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M143.627 22.4422C143.627 30.008 137.54 36.1422 130.031 36.1422C122.521 36.1422 116.434 30.008 116.434 22.4422C116.434 14.8764 122.521 8.74219 130.031 8.74219C137.54 8.74219 143.627 14.8758 143.627 22.4422Z",
    fill: "url(#paint32_linear_917_8848)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M129.48 3.73371C129.488 4.56442 129.496 5.39513 129.505 6.22584C129.506 6.34588 129.507 6.46464 129.508 6.58468C129.511 6.87457 129.759 7.1536 130.059 7.13955C130.355 7.12615 130.613 6.89564 130.61 6.58468C130.602 5.75397 130.594 4.92326 130.586 4.09255C130.584 3.97315 130.583 3.85375 130.582 3.73371C130.579 3.44319 130.331 3.16479 130.031 3.1782C129.735 3.19225 129.477 3.42275 129.48 3.73371Z",
    fill: "url(#paint33_linear_917_8848)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M129.466 38.3021C129.474 39.1328 129.482 39.9635 129.49 40.7942C129.491 40.9142 129.493 41.0336 129.494 41.153C129.496 41.4436 129.745 41.722 130.045 41.7085C130.34 41.6951 130.598 41.464 130.596 41.153C130.588 40.3223 130.58 39.4916 130.572 38.6609C130.57 38.5415 130.569 38.4221 130.568 38.3021C130.565 38.0109 130.316 37.7332 130.017 37.7466C129.721 37.7606 129.463 37.9911 129.466 38.3021Z",
    fill: "url(#paint34_linear_917_8848)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M148.586 21.6309C147.762 21.6424 146.937 21.6539 146.113 21.6647C145.994 21.6667 145.875 21.6679 145.757 21.6699C145.468 21.6743 145.192 21.9227 145.205 22.2247C145.219 22.5223 145.448 22.7841 145.757 22.7796C146.581 22.7681 147.405 22.7566 148.23 22.7451C148.349 22.7445 148.467 22.7419 148.586 22.74C148.874 22.7362 149.15 22.4878 149.137 22.1851C149.124 21.8889 148.895 21.6271 148.586 21.6309Z",
    fill: "url(#paint35_linear_917_8848)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M114.277 21.7598C113.453 21.7719 112.629 21.7828 111.804 21.7943C111.686 21.7962 111.567 21.7981 111.449 21.7994C111.161 21.8032 110.884 22.0516 110.898 22.3543C110.911 22.6512 111.14 22.9136 111.449 22.9091C112.273 22.8976 113.098 22.8861 113.922 22.8753C114.041 22.8734 114.16 22.8721 114.278 22.8702C114.566 22.867 114.842 22.618 114.829 22.3153C114.815 22.0178 114.585 21.756 114.277 21.7598Z",
    fill: "url(#paint36_linear_917_8848)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M142.854 8.34756C142.203 8.86156 141.552 9.37429 140.902 9.8883C140.81 9.96045 140.718 10.0332 140.626 10.1054C140.523 10.1871 140.465 10.3729 140.465 10.4981C140.465 10.6341 140.525 10.7969 140.626 10.8908C140.731 10.9878 140.869 11.06 141.016 11.053C141.171 11.0459 141.283 10.9859 141.405 10.8908C142.056 10.3768 142.707 9.8634 143.358 9.35067C143.45 9.27788 143.542 9.20508 143.634 9.13293C143.737 9.05184 143.794 8.86603 143.794 8.74088C143.794 8.60488 143.735 8.44206 143.634 8.3482C143.529 8.25178 143.391 8.17899 143.244 8.18602C143.088 8.19304 142.976 8.25242 142.854 8.34756Z",
    fill: "url(#paint37_linear_917_8848)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M117.405 33.4699C116.76 33.9903 116.115 34.5113 115.471 35.0317C115.379 35.1058 115.288 35.1799 115.196 35.2533C115.094 35.3369 115.035 35.5196 115.035 35.646C115.035 35.782 115.095 35.9448 115.196 36.0387C115.302 36.1351 115.439 36.2079 115.585 36.2015C115.741 36.1945 115.855 36.1351 115.975 36.0387C116.62 35.5183 117.264 34.9973 117.909 34.4762C118 34.4022 118.091 34.3287 118.183 34.2547C118.286 34.1717 118.344 33.989 118.344 33.862C118.344 33.7266 118.284 33.5631 118.183 33.4699C118.078 33.3729 117.94 33.3001 117.793 33.3071C117.639 33.3148 117.525 33.3729 117.405 33.4699Z",
    fill: "url(#paint38_linear_917_8848)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M115.871 10.0106C116.489 10.5648 117.107 11.1184 117.725 11.6733C117.812 11.7512 117.898 11.8284 117.985 11.9057C118.2 12.0992 118.554 12.1349 118.763 11.9057C118.956 11.695 118.994 11.3272 118.763 11.121C118.146 10.5667 117.527 10.0125 116.909 9.45828C116.822 9.38102 116.736 9.30248 116.65 9.22522C116.435 9.03239 116.08 8.99536 115.871 9.22522C115.679 9.43657 115.641 9.805 115.871 10.0106Z",
    fill: "url(#paint39_linear_917_8848)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M141.738 33.6316C142.455 34.0454 143.173 34.4591 143.89 34.8729C143.991 34.931 144.092 34.9904 144.194 35.0478C144.443 35.1921 144.807 35.1149 144.947 34.8493C145.085 34.5849 145.016 34.2433 144.749 34.0894C144.031 33.6757 143.314 33.2619 142.596 32.8481C142.495 32.7894 142.394 32.7313 142.293 32.6732C142.043 32.5289 141.679 32.6062 141.539 32.8731C141.402 33.1361 141.471 33.4777 141.738 33.6316Z",
    fill: "url(#paint40_linear_917_8848)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5589 82.6864C55.9239 85.4487 54.1623 88.1017 52.1965 90.6162C52.0032 90.8652 52.1902 91.2649 52.4988 91.3249C55.8226 91.9749 59.1469 92.6281 62.4675 93.273C65.2171 93.8087 69.2665 93.9454 73.4705 92.789C78.5318 91.3932 82.8479 87.4798 84.154 81.9285C85.2953 77.0783 80.5597 74.6462 76.6865 73.3666C71.9109 71.7902 67.0796 73.8155 63.2717 76.316C60.7971 77.9416 59.0791 80.1209 57.5589 82.6864Z",
    fill: "#A2DDD0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5007 90.9837C54.5754 90.2833 56.659 89.5784 58.621 88.5951C58.7838 88.5146 58.9429 88.4271 59.1013 88.3409C58.6983 88.8179 58.2978 89.2987 57.9207 89.7935C57.4417 90.4206 57.0532 91.1044 56.8327 91.8649C56.7623 92.1177 57.14 92.2761 57.2123 92.022C57.4302 91.2647 57.8124 90.6006 58.2895 89.9838C58.8447 89.2706 59.4365 88.5848 60.0075 87.8869C60.0373 87.8595 60.0481 87.825 60.0538 87.7956C61.3972 86.9815 62.6709 86.0569 64.0233 85.2505C65.4782 84.3847 66.9997 83.66 68.5605 83.0214C68.449 84.9568 66.9307 86.6067 65.8369 88.0855C65.1728 88.9845 64.5099 89.8823 63.8458 90.782C63.337 91.476 62.8161 92.195 62.8984 93.0979C62.9238 93.3622 63.3268 93.3047 63.3046 93.0391C63.2039 91.9696 64.1969 91.001 64.7824 90.2054C65.4643 89.2802 66.1455 88.3575 66.828 87.4336C67.8369 86.0691 68.9249 84.6165 68.9674 82.8561C71.2538 81.9436 73.6149 81.2049 75.9552 80.4763C76.7258 80.2375 77.4989 79.9968 78.2764 79.7778C76.7689 85.096 73.6435 89.8044 69.2107 93.1081C68.9991 93.2671 69.2532 93.5882 69.4648 93.4318C74.0262 90.0323 77.2403 85.1464 78.7333 79.6494C80.3265 79.2089 81.9418 78.8628 83.6008 78.7574C83.8625 78.7402 83.8036 78.3347 83.5418 78.3488C82.9291 78.3884 82.3239 78.4624 81.7212 78.5576C81.7124 78.5506 81.7028 78.5416 81.6908 78.5359C79.3721 77.2154 76.9076 76.2015 74.3291 75.5317C71.7588 74.8644 68.7418 74.2042 66.1474 75.056C65.8965 75.1364 66.0619 75.5131 66.3122 75.4308C67.6936 74.9781 69.1474 75.0438 70.57 75.2264C71.8476 75.3848 73.1105 75.6306 74.3507 75.9588C76.6992 76.5782 78.9602 77.4964 81.0863 78.6706C80.2574 78.827 79.4374 79.0275 78.6231 79.2523C78.5464 79.2235 78.4615 79.237 78.4139 79.3097C77.9818 79.4311 77.5496 79.5594 77.1187 79.6903C76.2359 79.9585 75.3519 80.2292 74.4723 80.5082C72.5903 79.6469 70.6733 79.0614 68.6245 78.7632C66.3534 78.4337 64.0702 78.1643 61.792 77.8693C61.5322 77.8322 61.4828 78.2428 61.7413 78.2773C63.9453 78.564 66.1474 78.8321 68.3483 79.1399C70.281 79.4119 72.0972 79.924 73.8786 80.6947C72.8374 81.028 71.8026 81.3709 70.7772 81.738C70.1321 81.9679 69.4921 82.2073 68.8565 82.4608C68.7665 82.434 68.648 82.4723 68.5929 82.5655C67.3812 83.0566 66.1905 83.5987 65.0366 84.2148C65.0321 84.2142 65.0251 84.2123 65.0188 84.211C63.6861 84.1669 62.5258 83.4627 61.2686 83.1089C59.9125 82.7258 58.6324 82.9346 57.2953 83.2775C57.0418 83.3426 57.0976 83.75 57.3504 83.6849C58.024 83.5125 58.7034 83.3349 59.4004 83.2973C60.1038 83.2558 60.7908 83.3765 61.4574 83.5955C62.4396 83.9198 63.3839 84.4 64.4079 84.5647C62.6488 85.5736 61.0366 86.8149 59.2597 87.7956C57.0703 89.0056 54.6939 89.8095 52.3359 90.6076C52.0869 90.6913 52.2517 91.0687 52.5007 90.9837Z",
    fill: "#E0FBF0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6066 71.8762C77.2333 72.131 78.9272 72.0754 80.5881 71.7198C81.8644 71.4465 83.0431 71.2409 83.4474 69.6676C84.2585 66.5108 83.4075 63.1062 81.7744 60.7373C81.4639 60.2891 81.1192 59.8868 80.758 59.5056C79.9811 58.5031 79.0457 57.6558 77.9678 57.0416C75.9647 55.8993 73.6612 55.5404 71.3526 55.5647C70.2119 55.5762 69.0662 55.6809 67.9224 55.8182C66.5308 55.9874 64.9769 56.4088 63.8071 55.4964C63.5473 55.2908 63.2286 55.5966 63.2393 55.9248C63.3148 58.0223 63.399 60.1486 63.9491 62.1197C64.4789 64.018 65.4858 65.5951 66.7545 66.9111C69.1758 69.4275 72.2182 71.3501 75.6066 71.8762Z",
    fill: "#A2DDD0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8102 71.4066C75.6448 70.5822 76.7443 70.2757 77.8875 70.4156C78.5345 70.4935 79.1314 70.5477 79.7734 70.3977C80.3887 70.2579 80.971 70.0005 81.5452 69.7439C80.7613 68.7861 79.9521 67.8468 79.0541 66.9957C79.0307 66.9727 79.0072 66.9535 78.9838 66.9312C75.9078 67.1132 73.5016 69.4923 70.4599 69.853C70.2393 69.8818 70.1785 69.537 70.4016 69.5082C73.3445 69.159 75.6879 66.9184 78.6308 66.61C77.5282 65.6427 76.2988 64.8547 75.0105 64.1524C74.5777 63.9155 74.1417 63.6831 73.7069 63.45C72.9002 63.6269 72.1924 64.0425 71.4408 64.3644C70.7862 64.6447 70.1126 64.8056 69.3991 64.8369C67.9726 64.8982 66.5658 64.5514 65.1393 64.6242C64.9188 64.6325 64.8567 64.2877 65.081 64.2782C66.479 64.2086 67.8573 64.5272 69.2539 64.4921C70.0759 64.4723 70.8224 64.266 71.5676 63.9244C72.1259 63.6671 72.6702 63.3906 73.2526 63.2099C71.7951 62.438 70.3407 61.6666 68.9491 60.7829C67.0487 60.903 64.9967 60.9228 63.5475 59.4791C63.3891 59.3207 63.6552 59.0921 63.813 59.2505C65.0506 60.4841 66.8091 60.5467 68.4536 60.4624C67.9308 60.1195 67.4194 59.7568 66.9207 59.3705C65.5595 58.3163 64.3212 57.1127 63.2927 55.7246C63.1597 55.5458 63.4239 55.3166 63.5582 55.4979C65.0436 57.5041 66.9618 59.0857 69.0347 60.4292C69.1209 60.426 69.1811 60.4803 69.2102 60.5448C69.4282 60.6859 69.65 60.8238 69.8718 60.9579C69.8503 60.4247 69.7603 59.9024 69.6253 59.391C69.3205 58.2474 68.7863 57.1568 68.2635 56.102C68.164 55.9008 68.4808 55.7508 68.5797 55.9538C69.3902 57.5948 70.2007 59.3016 70.2229 61.1686C70.3984 61.2746 70.5746 61.3748 70.7514 61.4789C71.7444 62.0504 72.7722 62.5708 73.7925 63.1026C73.8007 63.1058 73.8058 63.1084 73.8128 63.1129C74.359 63.397 74.9046 63.6875 75.4388 63.9883C75.7234 62.6378 75.2018 61.3071 74.6657 60.0857C74.0815 58.7531 73.5923 57.4499 73.4547 55.9877C73.4338 55.7642 73.7767 55.7042 73.7976 55.9276C73.8749 56.7424 74.0365 57.5456 74.3096 58.3182C74.5726 59.0711 74.9294 59.7868 75.2316 60.523C75.7094 61.6839 76.0428 62.9194 75.7538 64.1709C76.8805 64.8228 77.9603 65.5373 78.9375 66.4159C79.549 66.967 80.1162 67.5576 80.6631 68.1725C81.4007 66.709 80.8266 65.0176 80.3202 63.5656C79.7841 62.0363 79.4552 60.5403 79.6631 58.9108C79.6922 58.6873 80.037 58.716 80.0097 58.9414C79.8957 59.8271 79.9159 60.7197 80.0915 61.5945C80.286 62.5586 80.6713 63.4647 80.9666 64.3963C81.3855 65.7167 81.5921 67.1866 80.9077 68.447C81.5072 69.1373 82.0807 69.8498 82.6529 70.5624C82.7936 70.7355 82.5306 70.9666 82.3886 70.7904C82.1833 70.5337 81.9786 70.2802 81.7727 70.028C80.7245 70.4973 79.639 70.95 78.4686 70.8427C77.8412 70.7859 77.2481 70.6589 76.6188 70.7974C76.0142 70.9277 75.4756 71.2399 75.0345 71.6754C74.8755 71.8305 74.6505 71.5636 74.8102 71.4066Z",
    fill: "#E0FBF0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9707 203.035C6.9707 205.504 42.4361 207.504 86.1836 207.504C129.931 207.504 165.396 205.504 165.396 203.035C165.396 200.566 129.931 198.564 86.1836 198.564C42.4361 198.564 6.9707 200.566 6.9707 203.035Z",
    fill: "#C5EAE2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8964 202.145C31.8964 202.145 40.8214 185.686 34.897 183.59C30.9839 182.206 29.7101 197.602 29.7101 197.602C29.7101 197.602 29.3603 180.534 24.1684 182.716C20.2477 184.363 25.4859 196.685 25.4859 196.685C25.4859 196.685 19.7959 192.037 19.0785 194.956C17.9372 199.596 24.4846 202.23 24.4846 202.23L31.8964 202.145Z",
    fill: "#A2DDD0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0612 202.166L34.3799 188.525C34.4033 188.451 34.3628 188.372 34.288 188.347C34.2132 188.323 34.1334 188.363 34.1099 188.439L29.7615 202.171L30.0612 202.166Z",
    fill: "#E0FBF0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M28.937 202.178L25.8414 187.31C25.8255 187.232 25.7488 187.183 25.6741 187.198C25.5974 187.215 25.548 187.291 25.5632 187.368L28.6468 202.182L28.937 202.178Z",
    fill: "#E0FBF0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3445 202.196L21.4631 197.095C21.4017 197.043 21.3136 197.051 21.2629 197.109C21.2122 197.17 21.2173 197.26 21.2768 197.311L26.9161 202.2L27.3445 202.196Z",
    fill: "#E0FBF0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4102 182.415L38.6466 182.254C38.6282 182.227 36.8335 179.596 34.2183 180.115L34.2734 180.395C36.7062 179.914 38.3956 182.388 38.4102 182.415Z",
    fill: "#A2DDD0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9969 195.334L16.2744 195.267C15.9994 194.124 16.1097 193.256 16.602 192.685C17.391 191.772 18.9163 191.914 18.9309 191.915L18.9594 191.631C18.8929 191.624 17.2763 191.474 16.3898 192.497C15.8321 193.141 15.6997 194.097 15.9969 195.334Z",
    fill: "#A2DDD0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M136.206 201.007C136.206 201.007 125.529 180.775 134.203 180.99C137.77 181.08 140.851 197.166 140.851 197.166C140.851 197.166 140.15 182.486 147.286 184.79C151.146 186.038 145.306 197.166 145.306 197.166C145.306 197.166 150.593 189.98 153.57 192.021C158.418 195.344 149.522 201.062 149.522 201.062L136.206 201.007Z",
    fill: "#A2DDD0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M131.524 200.989C131.524 200.989 129.642 190.279 125.506 190.465C122.548 190.596 125.217 197.849 127.726 200.982C127.726 200.982 131.407 200.989 131.524 200.989Z",
    fill: "#A2DDD0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M138.8 201.021L134.352 185.168C134.322 185.059 134.211 184.997 134.106 185.027C134.001 185.057 133.94 185.168 133.97 185.275L138.386 201.018L138.8 201.021Z",
    fill: "#E0FBF0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M142.483 201.034L145.566 188.201C145.592 188.095 145.525 187.989 145.419 187.962C145.312 187.939 145.205 188.002 145.179 188.109L142.075 201.033H142.483V201.034Z",
    fill: "#E0FBF0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M129.573 200.981L126.728 193.827C126.687 193.724 126.572 193.675 126.47 193.715C126.367 193.756 126.318 193.874 126.358 193.975L129.144 200.981H129.573Z",
    fill: "#E0FBF0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M145.756 201.052L151.356 194.687C151.43 194.605 151.422 194.477 151.339 194.404C151.257 194.331 151.132 194.337 151.057 194.422L145.225 201.052H145.756Z",
    fill: "#E0FBF0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M138.53 180.535C138.554 180.535 138.577 180.531 138.601 180.524C138.704 180.484 138.756 180.368 138.715 180.265C138.644 180.072 136.912 175.56 133.963 174.512C132.877 174.127 131.765 174.263 130.658 174.919C130.562 174.976 130.532 175.097 130.587 175.193C130.641 175.288 130.764 175.32 130.859 175.263C131.86 174.673 132.861 174.545 133.829 174.889C136.606 175.875 138.327 180.361 138.343 180.407C138.373 180.487 138.45 180.535 138.53 180.535Z",
    fill: "#A2DDD0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2363 203.27C79.6655 203.27 73.5059 197.063 73.5059 189.435C73.5059 184.461 76.2042 179.855 80.4645 177.413V42.5647C80.4645 38.8026 83.5025 35.7422 87.2356 35.7422C90.97 35.7422 94.0073 38.8026 94.0073 42.5647V177.413C98.269 179.855 100.967 184.46 100.967 189.435C100.967 197.064 94.8071 203.27 87.2363 203.27Z",
    fill: "#F64C4C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3147 178.45V42.5643C92.3147 39.7383 90.041 37.4473 87.2356 37.4473C84.4308 37.4473 82.1571 39.7383 82.1571 42.5643V178.45C78.0507 180.381 75.1984 184.568 75.1984 189.435C75.1984 196.133 80.5881 201.564 87.2362 201.564C93.8837 201.564 99.274 196.133 99.274 189.435C99.274 184.567 96.421 180.381 92.3147 178.45Z",
    fill: "#E9F3F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1578 72.5332V178.452C78.0514 180.383 75.1991 184.57 75.1991 189.437C75.1991 196.135 80.5887 201.566 87.2369 201.566C93.8844 201.566 99.2746 196.135 99.2746 189.437C99.2746 184.569 96.4217 180.382 92.3154 178.452V72.5332H82.1578Z",
    fill: "#E62225"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7006 189.63C95.7006 194.339 91.9111 198.158 87.2363 198.158C82.5621 198.158 78.7732 194.339 78.7732 189.63C78.7732 184.919 82.5628 181.102 87.2363 181.102C91.9111 181.101 95.7006 184.919 95.7006 189.63Z",
    fill: "#F28B90"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8897 193.319C84.9651 190.423 89.6729 190.385 90.5873 193.427C90.6665 193.691 91.0797 193.578 90.9992 193.311C89.9567 189.841 84.7008 189.91 83.4772 193.204C83.3802 193.465 83.7934 193.578 83.8897 193.319Z",
    fill: "#003940",
    stroke: "#003940"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0164 186.895C85.0164 187.401 85.0164 187.905 85.0164 188.409C85.0164 188.688 85.4448 188.688 85.4448 188.409C85.4448 187.905 85.4448 187.401 85.4448 186.895C85.4448 186.619 85.0164 186.618 85.0164 186.895Z",
    fill: "#003940",
    stroke: "#003940"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0315 186.895C89.0315 187.401 89.0315 187.905 89.0315 188.409C89.0315 188.688 89.4599 188.688 89.4599 188.409C89.4599 187.905 89.4599 187.401 89.4599 186.895C89.4599 186.619 89.0315 186.618 89.0315 186.895Z",
    fill: "#003940",
    stroke: "#003940"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1024 119.52C48.8703 118.241 49.6662 116.964 50.7657 115.955C51.1078 115.642 52.4776 114.121 52.9269 114.345C53.2154 114.488 52.0329 116.225 52.0329 116.225C51.7489 116.649 51.5027 117.155 51.4068 117.681C51.5465 117.522 51.6991 117.373 51.875 117.247C52.094 117.088 52.4973 116.811 52.7736 117.031C53.0591 117.253 52.8726 117.719 52.7752 117.983C52.6642 118.279 52.5463 118.558 52.495 118.873C52.4557 119.113 52.4376 119.349 52.353 119.58C52.1658 120.084 51.7565 120.547 51.4129 120.942C51.0217 121.39 50.5535 121.651 50.0899 122.006C49.5379 122.43 49.2985 123.081 49.0342 123.707C48.8363 124.173 48.6393 124.64 48.4422 125.107L46.5619 122.17C47.0656 121.28 47.5753 120.397 48.1024 119.52Z",
    fill: "#BF7968"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6098 117.368V110.053C52.6098 109.061 53.4156 108.254 54.4056 108.254H70.9507C71.9406 108.254 72.7464 109.062 72.7464 110.053V111.306C72.7464 111.421 72.8393 111.515 72.954 111.515H74.3435C74.8328 111.515 75.2315 111.914 75.2315 112.406V114.775C75.2315 115.278 74.8238 115.687 74.3216 115.687H72.954C72.8393 115.687 72.7464 115.781 72.7464 115.896V117.367C72.7464 118.359 71.9406 119.166 70.9507 119.166H54.4056C53.4156 119.167 52.6098 118.36 52.6098 117.368ZM72.8717 111.862C72.6127 111.862 72.4028 111.65 72.4028 111.389V110.053C72.4028 109.251 71.7511 108.6 70.9507 108.6H54.4056C53.6044 108.6 52.9534 109.251 52.9534 110.053V117.368C52.9534 118.169 53.6051 118.82 54.4056 118.82H70.9507C71.7519 118.82 72.4028 118.169 72.4028 117.368V115.815C72.4028 115.554 72.612 115.341 72.8717 115.341H74.3216C74.6342 115.341 74.8887 115.088 74.8887 114.775V112.407C74.8887 112.105 74.644 111.862 74.3435 111.862H72.8717Z",
    fill: "#4087AA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8249 117.871H57.5043C57.5983 117.871 57.6748 117.61 57.6748 117.29V110.842C57.6748 110.522 57.5983 110.262 57.5043 110.262H54.8449C54.7397 110.262 54.6542 110.552 54.6542 110.911V117.29C54.6544 117.61 54.7309 117.871 54.8249 117.871Z",
    fill: "#E62225"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9189 117.871H59.4512C59.7211 117.871 59.9402 117.579 59.9402 117.221V110.911C59.9402 110.552 59.7211 110.262 59.4512 110.262H58.9189C58.6485 110.262 58.4299 110.552 58.4299 110.911V117.221C58.4299 117.579 58.6485 117.871 58.9189 117.871Z",
    fill: "#F28B90"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0326 116.541C72.9994 116.343 72.8385 115.819 72.5214 116.003C72.2004 116.192 72.2888 117.033 72.2533 117.34C72.1604 118.14 71.6975 118.699 71.1379 119.216C71.1984 119.012 71.2407 118.804 71.2512 118.587C71.2656 118.317 71.2844 117.823 70.9522 117.706C70.6109 117.584 70.3201 117.99 70.1517 118.215C69.9629 118.466 69.7938 118.714 69.5552 118.929C69.3755 119.089 69.1852 119.23 69.0387 119.425C68.717 119.857 68.5471 120.454 68.3998 120.958C68.2337 121.529 68.2662 122.068 68.2171 122.654C68.1574 123.349 67.7383 123.904 67.3547 124.461C67.07 124.878 66.7846 125.297 66.4984 125.714L69.966 125.745C70.444 124.84 70.9129 123.93 71.366 123.016C72.026 121.676 72.7313 120.337 72.9276 118.84C73.0228 118.121 73.1534 117.263 73.0326 116.541Z",
    fill: "#BF7968"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5902 109.27C48.4769 109.121 47.8909 108.619 47.7301 108.263C47.2929 107.297 47.4582 106.395 46.867 105.605L39.937 106.241C39.9099 106.274 39.8744 106.304 39.8487 106.338C39.2491 107.137 38.9305 108.151 38.7273 109.119C38.4849 110.279 38.4373 111.504 38.6292 112.674C38.6835 113.002 38.9463 114.193 39.4047 114.508C39.4205 114.889 39.4364 115.272 39.4515 115.654C39.4689 116.081 39.4288 116.573 39.5036 116.994L46.5256 116.349C46.5015 115.855 46.4584 115.359 46.3958 114.871C46.9123 114.444 47.3948 113.953 47.6138 113.312C47.7527 112.905 47.7399 112.488 47.7339 112.064C47.7233 111.332 47.8131 110.79 48.3735 110.289C48.5796 110.104 48.7639 109.959 48.7337 109.652C48.7186 109.512 48.6763 109.382 48.5902 109.27Z",
    fill: "#BF7968"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7718 193.996L34.1368 193.961C34.0107 194.804 33.5024 195.547 33.4345 196.403C33.3748 197.162 33.7864 197.9 34.4819 198.211C34.8949 198.395 35.3616 198.435 35.8034 198.49C36.338 198.56 36.8855 198.66 37.4254 198.663C38.21 198.666 38.842 198.249 38.8956 197.417C38.9319 196.863 38.7431 196.314 38.6933 195.768C38.6374 195.174 38.6736 194.581 38.7718 193.996Z",
    fill: "#12252E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2273 193.999C39.1654 191.288 39.1495 188.571 39.4463 185.876C39.7884 182.77 40.8192 179.814 40.9853 176.684C41.0729 175.018 44.4121 161.132 45.3281 158.117C46.3098 161.701 47.2454 165.298 48.4634 168.79C49.1151 170.666 49.2556 172.503 49.39 174.494C49.5131 176.292 49.6905 178.084 49.9254 179.869C50.4215 183.652 53.0048 193.979 53.0365 194.104L58.133 194.14C58.025 190.626 56.8039 180.066 56.9723 178.179C57.1385 176.309 57.5402 157.859 55.7709 150.639L35.9311 150.49C35.4713 153.738 34.9699 156.998 34.7448 160.271C34.4745 164.205 34.9034 168.134 34.8747 172.068C34.8468 175.998 33.9263 179.776 33.6612 183.676C33.4279 187.098 33.5509 190.535 33.7201 193.957L39.2273 193.999Z",
    fill: "#2A817D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2813 120.666C34.7478 119.191 36.7859 118.857 38.4381 117.751C38.5386 117.493 38.9237 116.576 39.0528 116.452C39.3285 116.185 46.577 116.184 46.7107 116.33C47.1245 116.769 47.5013 117.315 47.746 117.913C48.2716 118.185 48.8243 118.386 49.4247 118.481C50.1443 118.592 50.8496 118.807 51.5413 119.061C52.4905 119.41 53.4488 119.831 54.3633 120.337V130.678C54.361 130.675 54.3587 130.675 54.3565 130.674C53.8513 137.929 56.6174 144.989 57.3823 152.156C55.7165 152.2 37.868 153.558 34.8701 154.331C34.1837 151.14 34.0538 147.87 34.047 144.614C34.0387 141.719 34.124 138.822 33.976 135.925C33.9058 134.526 33.7789 133.124 33.5584 131.738C33.3138 130.208 32.906 128.748 32.4937 127.267C31.8624 124.976 31.5732 122.388 33.2813 120.666Z",
    fill: "#2F627C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8415 129.247L52.924 119.711C53.2811 119.833 53.6338 119.964 53.9781 120.116C55.3797 120.734 56.6574 121.671 57.9101 122.62C59.2007 123.597 60.4859 124.577 61.8859 125.332C62.9628 125.914 64.0804 126.375 65.2214 126.716C65.6231 125.792 67.5714 123.508 67.5714 123.508C68.8664 125.207 70.7226 125.324 70.7226 125.324C70.6833 126.4 70.6493 127.48 70.5995 128.555C70.5225 130.23 70.1728 131.785 67.8968 132.755C67.7247 132.828 67.5397 132.886 67.3554 132.916C65.9101 133.147 64.3953 132.676 62.9892 132.176C61.5378 131.656 60.1197 131.018 58.663 130.525C57.9268 130.278 57.1822 130.067 56.4286 129.931C55.9951 129.852 54.2764 129.316 53.8415 129.247Z",
    fill: "#2F627C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2374 194.104L57.8739 194.136C57.9849 194.982 58.4841 195.733 58.5392 196.591C58.5883 197.353 58.1662 198.082 57.4646 198.383C57.0493 198.561 56.5841 198.592 56.1401 198.644C55.604 198.705 55.055 198.795 54.5173 198.789C53.732 198.783 53.106 198.353 53.0637 197.524C53.035 196.971 53.2328 196.422 53.291 195.879C53.3537 195.284 53.328 194.689 53.2374 194.104Z",
    fill: "#12252E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4814 109.433C37.4972 109.517 37.5154 109.603 37.532 109.689C37.5629 111.727 38.1535 114.28 40.141 115.088C40.7466 115.335 41.4194 115.33 42.0364 115.548C42.5952 115.741 42.9154 115.762 43.4341 115.45C44.3607 114.892 45.5138 114.419 45.7298 113.246C45.8483 112.602 45.7494 111.937 45.8808 111.293C46.0311 110.552 46.4321 109.866 46.7024 109.165C47.0128 108.366 47.8381 107.554 48.2489 106.719C48.5427 106.381 48.7715 106.004 48.7715 105.577C48.7692 104.81 48.554 103.913 48.1923 103.24C47.3201 101.627 45.5961 101.963 44.0685 102.042C43.1125 102.09 42.1716 101.827 41.2163 101.905C40.4468 101.965 39.6864 102.211 39.0362 102.637C37.7313 103.489 36.9898 104.969 37.0615 106.531C37.1061 107.501 37.316 108.476 37.4814 109.433Z",
    fill: "#12252E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_917_8848",
    x1: 86.0641,
    y1: 199.415,
    x2: 86.0641,
    y2: 128.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394,
    stopColor: "#FFE818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#F67D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7815,
    stopColor: "#D63207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9684,
    stopColor: "#BB1807"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_917_8848",
    x1: 86.2331,
    y1: 192.882,
    x2: 86.2331,
    y2: 148.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394,
    stopColor: "#FFE818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#F67D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7815,
    stopColor: "#D63207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9684,
    stopColor: "#BB1807"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_917_8848",
    x1: 85.2903,
    y1: 202.248,
    x2: 85.2903,
    y2: 129.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0054,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#FFA018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7973,
    stopColor: "#D00800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_917_8848",
    x1: 86.2975,
    y1: 200.053,
    x2: 86.2975,
    y2: 143.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394,
    stopColor: "#FFE818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#F67D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7815,
    stopColor: "#D63207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9684,
    stopColor: "#BB1807"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_917_8848",
    x1: 95.9189,
    y1: 202.042,
    x2: 95.9189,
    y2: 129.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0054,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#FFA018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7973,
    stopColor: "#D00800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_917_8848",
    x1: 84.9979,
    y1: 201.3,
    x2: 84.9979,
    y2: 146.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0471,
    stopColor: "#FFFF71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3038,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_917_8848",
    x1: 65.0921,
    y1: 188.545,
    x2: 65.0921,
    y2: 117.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394,
    stopColor: "#FFE818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#F67D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7815,
    stopColor: "#D63207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9684,
    stopColor: "#BB1807"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_917_8848",
    x1: 76.4383,
    y1: 188.546,
    x2: 76.4383,
    y2: 117.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394,
    stopColor: "#FFE818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#F67D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7815,
    stopColor: "#D63207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9684,
    stopColor: "#BB1807"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_917_8848",
    x1: 76.3348,
    y1: 197.737,
    x2: 76.3348,
    y2: 178.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0491,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5097,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_917_8848",
    x1: 88.0472,
    y1: 197.739,
    x2: 88.0472,
    y2: 178.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0491,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5097,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_917_8848",
    x1: 117.624,
    y1: 188.547,
    x2: 117.624,
    y2: 117.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394,
    stopColor: "#FFE818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#F67D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7815,
    stopColor: "#D63207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9684,
    stopColor: "#BB1807"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_917_8848",
    x1: 125.842,
    y1: 188.544,
    x2: 125.842,
    y2: 117.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394,
    stopColor: "#FFE818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#F67D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7815,
    stopColor: "#D63207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9684,
    stopColor: "#BB1807"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_917_8848",
    x1: 67.358,
    y1: 197.738,
    x2: 67.358,
    y2: 178.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0491,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5097,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_917_8848",
    x1: 97.9624,
    y1: 197.738,
    x2: 97.9624,
    y2: 178.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0491,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5097,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_917_8848",
    x1: 44.3891,
    y1: 188.547,
    x2: 44.3891,
    y2: 117.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0394,
    stopColor: "#FFE818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#F67D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7815,
    stopColor: "#D63207"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9684,
    stopColor: "#BB1807"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.6968 167.55) scale(20.0614 20.2139)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0598,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6983,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.0157 156.564) scale(24.0153 24.1978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0598,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6983,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.5979 176.863) scale(13.6589 13.7628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0598,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6983,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.3702 132.393) scale(17.085 17.2148)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.222 144.953) scale(12.4283 12.5228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.2758 144.737) scale(7.83122 7.89075)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.738 176.592) scale(6.8626 6.91476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6738 164.849) scale(18.3289 18.4682)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.7449 155.614) scale(9.60562 9.67863)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.6124 185.64) scale(14.4803 14.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1465,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6983,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.2884 182.021) scale(20.1891 20.3426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1465,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6983,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.3982 149.368) scale(17.4287 17.5611)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1465,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4352,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.108 125.865) scale(14.4803 14.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1465,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4352,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.488 149.628) scale(17.126 17.2561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1465,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4352,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7896 160.429) scale(8.75653 8.82308)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1465,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4352,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_917_8848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.5749 207.018) scale(30.0092 30.2373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6081,
    stopColor: "#FFFF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_917_8848",
    x1: 85.7609,
    y1: 201.846,
    x2: 85.7609,
    y2: 152.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    stopColor: "#FFA018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D00800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_917_8848",
    x1: 143.627,
    y1: 8.74219,
    x2: 115.609,
    y2: 35.2709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_917_8848",
    x1: 130.61,
    y1: 3.17773,
    x2: 128.554,
    y2: 3.73705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_917_8848",
    x1: 130.596,
    y1: 37.7461,
    x2: 128.54,
    y2: 38.3053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_917_8848",
    x1: 149.137,
    y1: 21.6309,
    x2: 148.478,
    y2: 23.7821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_917_8848",
    x1: 114.829,
    y1: 21.7598,
    x2: 114.17,
    y2: 23.9119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_917_8848",
    x1: 143.794,
    y1: 8.18555,
    x2: 140.873,
    y2: 11.4216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_917_8848",
    x1: 118.344,
    y1: 33.3066,
    x2: 115.39,
    y2: 36.5271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_917_8848",
    x1: 118.922,
    y1: 9.06641,
    x2: 115.853,
    y2: 12.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_917_8848",
    x1: 145.017,
    y1: 32.6016,
    x2: 142.547,
    y2: 35.9205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureAbove40);
export default __webpack_public_path__ + "static/media/Temperature- Above 40.27b1e26de11dc3feb73cf5aa60c32d09.svg";
export { ForwardRef as ReactComponent };